"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_CUSTOMER = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.UPDATE_CUSTOMER = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateCustomer($updates: CustomerUpdateInput!) {\n    updateCustomer(updates: $updates) {\n      email\n      first_name\n      id\n      last_name\n      billing_phone\n    }\n  }\n"], ["\n  mutation UpdateCustomer($updates: CustomerUpdateInput!) {\n    updateCustomer(updates: $updates) {\n      email\n      first_name\n      id\n      last_name\n      billing_phone\n    }\n  }\n"])));
var templateObject_1;
